import { createContext } from 'react';

export const initialWithdraw = {
  bankAccount: {},
  subAccount: {},
  amountCents: 0,
  skipDocuments: true,
};

export const TransferContext = createContext<any>({
  transferData: {},
  setTransferData: () => {},
  mode: 'create',
});
